<template>
  <el-container class="doc" direction='vertical'>
    <div class="search-container">
      <div class="v-search-btn">
        <el-input style="margin-left:16px;" v-model="valueid" clearable placeholder="请输入商品名称"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="clickSearch" size="medium">查询</el-button>
      </div>
      <el-button  style="margin-right:16px;" type="primary"  @click="handleGoods(null)"  size="medium">新增商品</el-button>
    </div>
    <el-container direction='vertical' class="mian-container">
      <div class="scrollbar-container">
        <el-scrollbar>
          <el-table v-loading="isLoading" :data="tableData" stripe highlight-current-row>
            <el-table-column width="60" align="center" label="序号" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                  <span>{{(page - 1) * pageSize + scope.$index + 1}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="商品封面">
              <template slot-scope="scope">
                  <img width="60" :src="scope.row.coverimg" />
              </template>
            </el-table-column>
            <el-table-column align="center" label="商品名称">
              <template slot-scope="scope">
               <span>{{scope.row.title}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="所需积分">
              <template slot-scope="scope">
               <span>{{ scope.row.needpoints }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="库存">
              <template slot-scope="scope">
               <span>{{ scope.row.stock }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="兑换次数">
              <template slot-scope="scope">
               <span>{{ scope.row.exchanged }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="有效期时长">
              <template slot-scope="scope">
               <span v-if="scope.row.expiretype === '3' " >当月</span>
               <template v-else>
                <span v-if="scope.row.expire === '0' ">永久有效</span>
                <span v-else>{{scope.row.expire }}{{scope.row.expiretype === '1' ? '天' : '个月'}}</span>
               </template>
              </template>
            </el-table-column>
            <el-table-column align="center"  label="商品状态">
              <template slot-scope="scope">
               <span><el-tag :type="scope.row.status === '1'? 'success':'danger'">{{scope.row.status === '1'? '上架':'下架'}}</el-tag></span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="排序">
              <template slot-scope="scope">
               <span>{{ scope.row.listorder }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="250">
              <template slot-scope="scope">
                <el-button @click="handleGoods (scope.row)" size="mini">
                  <span>编辑</span>
                </el-button>
                <el-button @click="handleDelete (scope.row.id)" size="mini">
                  <span>删除</span>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </div>
      <el-pagination @current-change="currentChange" background v-if="total>20" layout="prev, pager, next" :current-page="page" :page-size="pageSize" :total="total">
      </el-pagination>
    </el-container>
    <goods-modal ref="modalgoods" @ok="modalGoodOk"></goods-modal>
  </el-container>
</template>
<script>
import {
  goodsList,
  goodsDelete
} from '@/views/webpc/CreditMall/GoodsApp/apis'
import GoodsModal from './modules/GoodsModal'
export default {
  components: { GoodsModal },
  data () {
    return {
      isLoading: false,
      pageSize: 20,
      page: 1,
      total: 0,
      valueid: '',
      tableData: []
    }
  },
  methods: {
    // 分页
    currentChange (val) {
      this.page = val
      this.loadData()
    },
    loadData () {
      this.isLoading = true
      let data = new FormData()
      data.append('page', this.page)
      data.append('size', this.pageSize)
      data.append('keywords', this.valueid)
      goodsList(data)
        .then((result) => {
          this.isLoading = false
          if (result) {
            this.tableData = result.data.list
            this.total = result.data.pager.records
          }
        })
        .catch((error) => {
          if (error) {
            this.isLoading = false
          }
        })
    },
    clickSearch () {
      this.page = 1
      this.loadData()
    },
    handleGoods (obj) {
      this.$refs.modalgoods.show(obj)
    },
    handleDelete (id) {
      this.$confirm('确认删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.getDelete(id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    getDelete (id) {
      let data = new FormData()
      data.append('id', id)
      goodsDelete(data)
        .then(result => {
          if (result) {
            this.loadData()
            this.$message({
              type: 'success',
              message: '操作成功!'
            })
          }
        })
    },
    modalGoodOk () {
      this.loadData()
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>

<style scoped lang="less">
</style>



// WEBPACK FOOTER //
// src/views/webpc/CreditMall/GoodsApp/goods.vue